import React, {useState} from 'react';
import TerrainIcon from '@mui/icons-material/Terrain';
import PlaceIcon from '@mui/icons-material/Place';
import PublicIcon from '@mui/icons-material/Public';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const GeographySection = () => {
    const [activeSection, setActiveSection] = useState(null);

    const geographyData = [
        {
            icon: <TerrainIcon sx={{fontSize: 40}} className="text-[#228B22]"/>,
            title: "Paysages et Reliefs",
            description: "Ambalavao est entourée par le massif de l'Andringitra, offrant des paysages spectaculaires entre montagnes et vallées.",
            details: "Le relief varié crée un microclimat unique, propice à une végétation diverse et à l'agriculture traditionnelle."
        },
        {
            icon: <PlaceIcon sx={{fontSize: 40}} className="text-[#228B22]"/>,
            title: "Localisation",
            description: "Située dans la région Haute Matsiatra, Ambalavao est un carrefour entre les hauts plateaux et la côte Est de Madagascar.",
            details: "Cette position stratégique en fait un point de passage important pour le commerce et les échanges culturels."
        },
        {
            icon: <PublicIcon sx={{fontSize: 40}} className="text-[#228B22]"/>,
            title: "Richesses Naturelles",
            description: "La commune est proche de parcs naturels, tels que le parc national d'Andringitra, abritant une biodiversité unique.",
            details: "La région abrite des espèces endémiques et des écosystèmes remarquables qui attirent chercheurs et écotouristes."
        },
    ];

    return (
        <section className="bg-gradient-to-br from-zinc-50 to-white py-24">
            <div className="max-w-7xl mx-auto px-4">
                {/* Header */}
                <div className="relative text-center mb-24">
                    <h2 className="text-5xl font-bold text-zinc-800">
                        Notre <span className="text-[#228B22]">Territoire</span>
                    </h2>
                    <div
                        className="absolute w-24 h-1 bg-[#228B22] bottom-0 left-1/2 transform -translate-x-1/2 translate-y-8"/>
                </div>

                {/* Geography Content */}
                <div className="relative space-y-32">
                    {geographyData.map((item, index) => (
                        <div key={index} className="relative">
                            <div
                                className={`flex flex-col md:flex-row ${
                                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                                } items-start gap-16 group`}
                            >
                                {/* Icon Section */}
                                <div className="w-full md:w-1/3 flex justify-center">
                                    <div className="relative">
                                        {/* Background blur effect */}
                                        <div
                                            className="absolute -inset-4 bg-[#228B22]/5 rounded-full blur-2xl transition-all duration-300 group-hover:bg-[#228B22]/10"/>

                                        {/* Icon container */}
                                        <div className="relative w-24 h-24 flex items-center justify-center">
                                            {item.icon}
                                            <div
                                                className="absolute inset-0 border-2 border-[#228B22]/20 rounded-full transform transition-transform duration-300 group-hover:scale-110"/>
                                        </div>
                                    </div>
                                </div>

                                {/* Content Section */}
                                <div className="flex-1 space-y-6">
                                    <div className="space-y-4">
                                        <h3 className="text-3xl font-bold text-zinc-800 group-hover:text-[#228B22] transition-colors">
                                            {item.title}
                                        </h3>
                                        <p className="text-lg text-zinc-600">
                                            {item.description}
                                        </p>
                                    </div>

                                    {/* Expandable Section */}
                                    <div className="pb-8">
                                        <button
                                            onClick={() => setActiveSection(activeSection === index ? null : index)}
                                            className="flex items-center gap-2 text-[#228B22] font-medium hover:opacity-80 transition-opacity"
                                        >
                                            <KeyboardArrowRightIcon
                                                className={`transform transition-transform duration-300 ${
                                                    activeSection === index ? 'rotate-90' : ''
                                                }`}
                                            />
                                            <span>
                        {activeSection === index ? 'Voir moins' : 'En savoir plus'}
                      </span>
                                        </button>

                                        <div className={`mt-4 transition-all duration-300 ease-in-out overflow-hidden ${
                                            activeSection === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                                        }`}>
                                            <p className="text-zinc-600 pl-6 border-l-2 border-[#228B22]">
                                                {item.details}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Timeline connector */}
                            {index < geographyData.length - 1 && (
                                <div className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-full">
                                    <div className="relative h-32">
                                        <div
                                            className="absolute top-0 left-1/2 transform -translate-x-1/2 w-px h-full bg-gradient-to-b from-[#228B22] to-transparent"/>
                                        <div
                                            className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-2 rounded-full bg-[#228B22]"/>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GeographySection;